'use client';

import NoibuScript from '@/app/head/NoibuScript';

import AffiliatesScript from './head/AffiliatesScript';
import AffirmScript from './head/AffirmScript';
import DecagonScript from './head/DecagonScript';
import SegmentScript from './head/SegmentScript';

const Scripts = () => {
  return (
    <>
      <SegmentScript />
      <AffiliatesScript />
      <AffirmScript />
      <NoibuScript />
      <DecagonScript />
    </>
  );
};

export default Scripts;
